<div class="main-container" data-cy="referral-portal-container">
<div class="header-main" data-cy="referral-portal-header">
  @if (this.PracticeName) {
    <div class="header-practice-name">
      <span data-cy="referral-portal-practice-name">{{this.PracticeName}}</span>
    </div>
  }
  <div class="header-logo">
    <img alt="TDO Logo" width="90px" src="../../../assets/Images/navbar-icons/v2/tdos_white.png" data-cy="referral-portal-logo"/>
  </div>
  @if (this.ReferralToDoctor) {
    <div class="header-referral-doctor">
      <span data-cy="referral-portal-to-doctor">Referral to {{this.ReferralToDoctor}}</span>
    </div>
  }
  @if (this.ReferralName) {
    <div class="header-referral-name">
      <span data-cy="referral-portal-name">{{this.ReferralName}}</span>
    </div>
  }
</div>
@if (isLoading) {
  <div class="loading-container" data-cy="referral-portal-loading">
    <app-tdo-progress-spinner data-cy="referral-portal-spinner"></app-tdo-progress-spinner>
  </div>
}
@if (this.authorizedUser && !isLoading) {
  <div id="divLandingCont" data-cy="referral-portal-content">
    <div id="divDBInfo" data-cy="referral-portal-provider-selection">
      @if (doctorList.length > 1) {
        <div class="divDBInfoScroll">
          <mat-radio-group [(ngModel)]="this.currentProvider"
            class="radio-group" data-cy="referral-portal-provider-group">
            @for (ent of doctorList; track ent; let i = $index) {
              <mat-radio-button class="radio-button"
                (click)="changeDr(ent, $event)"
                [value]="ent"
                [attr.data-cy]="'SelectedProvider-' + i">
                {{(ent.Title !== null ? ent.Title + ' ' : '' ) + ent.dataContact.FirstName + ' ' + ent.dataContact.LastName}}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }
    </div>
    <div id="divDBdisplay" data-cy="referral-portal-display">
      <div class="main-content-wrapper">
        <div class="content-column-left">
          <mat-card class="Card-style card-fixed-height" data-cy="referral-portal-doctor-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-portal-doctor-title">Referring Doctor</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="content-card-1">
              <div class="card-content-wrapper">
                <mat-grid-list cols="1" rowHeight="50px" class="grid-list-container">
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input [autocomplete]="name" name="name" placeholder="Full Name" placeholderPosition="above"
                      cypressControlIdentifier="referring-doctor-Fullname"
                      [isRequired]="true"
                      type ="text"
                      [value]="this.ReferringDoctor.FullName"
                    (inputFinished)="this.ReferringDoctor.FullName = $event" style="width: 100%" data-cy="referral-portal-doctor-fullname-input"></tdo-input>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input name="email" [autocomplete]="email" type="email" placeholder="Email Address" placeholderPosition="above"
                      cypressControlIdentifier="referring-doctor-Email"
                      style="width: 100%"
                      [isRequired]="true"
                      type ="text"
                      [value]="this.ReferringDoctor.email"
                    (inputFinished)="this.ReferringDoctor.email = $event" data-cy="referral-portal-doctor-email-input"></tdo-input>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input name="phone" [autocomplete]="phone" type="phone" widthString="100%" placeholder="Phone" [restrictTo]="'[0-9]'"
                      cypressControlIdentifier="referring-doctor-Phone"
                      [isRequired]="true" placeholderPosition="above"
                      style="width: 100%"
                      [value]="this.ReferringDoctor.phone"
                    (inputFinished)="this.ReferringDoctor.phone = $event" data-cy="referral-portal-doctor-phone-input"></tdo-input>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style card-fixed-height" data-cy="referral-portal-patient-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-portal-patient-title">Patient Information</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="content-card-1">
              <div class="card-content-wrapper">
                <mat-grid-list [cols]="isMobile ? 1 : 2" rowHeight="50px" class="grid-list-container">
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input placeholder="First Name" placeholderPosition="above"
                      cypressControlIdentifier="patient-FirstName"
                      style="width: 100%"
                      [isRequired]="true"
                      type ="text"
                      [value]="this.ReferralData.Patient_FirstName"
                    (inputFinished)="this.ReferralData.Patient_FirstName = $event" data-cy="referral-portal-patient-firstname-input"></tdo-input>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input placeholder="Last Name" placeholderPosition="above"
                      cypressControlIdentifier="patient-LastName"
                      style="width: 100%"
                      type ="text"
                      [isRequired]="true"
                      [value]="this.ReferralData.Patient_LastName"
                    (inputFinished)="this.ReferralData.Patient_LastName = $event" data-cy="referral-portal-patient-lastname-input"></tdo-input>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
                    <tdo-date-input widthString="100%" placeholder="Date Of Birth" [isRequired]="false"
                      placeholderPosition="center"
                      cypressControlIdentifier="patient-DOB"
                      style="width: 100%"
                      [valueAsDate]="getDate(this.ReferralData.Patient_DOB)"
                    (dateChanged)="this.ReferralData.Patient_DOB = $event; this.ReferralData.Patient_DOB = $event" data-cy="referral-portal-patient-dob-input"></tdo-date-input>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input type="email" placeholder="Email" placeholderPosition="above"
                      cypressControlIdentifier="patient-Email"
                      style="width: 100%"
                      [value]="this.ReferralData.Patient_email"
                    (inputFinished)="this.ReferralData.Patient_email = $event" data-cy="referral-portal-patient-email-input"></tdo-input>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                    <tdo-input type="phone" placeholder="Phone" placeholderPosition="above"
                      cypressControlIdentifier="patient-Phone"
                      style="width: 100%"
                      [value]="this.ReferralData.Patient_phone"
                    (inputFinished)="this.ReferralData.Patient_phone = $event" data-cy="referral-portal-patient-phone-input"></tdo-input>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="content-column-middle">
          <mat-card class="Card-style card-fixed-height" data-cy="referral-portal-schedule-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-portal-schedule-title">Schedule*</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="divDBInfoScroll content-card-1">
              @if (currentProvider) {
                <div class="card-content-wrapper">
                  <mat-radio-group [(ngModel)]="this.ReferralData.ReferralScheduleItemID"
                    class="radio-group" data-cy="referral-portal-schedule-group">
                    @for (ent of currentProvider.cfgReferralSchedule; track ent; let i = $index) {
                      <mat-radio-button class="radio-button"
                        (click)="changeReferralSchedule(ent)"
                        [value]="ent.ReferralScheduleItemID"
                        [attr.data-cy]="'ReferralSchedule-' + i">
                        {{ent.ItemName}}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              }
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style card-fixed-height" data-cy="referral-portal-insurance-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-portal-insurance-title">
                <div class="insurance-title-wrapper">
                  <span>Insurance</span>
                  <div class="insurance-self-checkbox">
                    <input #checkBox type="checkbox" id="check" [(ngModel)]="SelfInsurance"
                      [attr.data-cy]="'SelfInsurance'"
                      (change)="SelfChecked($event)" data-cy="referral-portal-insurance-self-checkbox">
                      <span>Self</span>
                    </div>
                  </div>
                </mat-card-title>
              </mat-card-title-group>
              <mat-card-content class="content-card-1">
                <div class="card-content-wrapper">
                  <mat-grid-list [cols]="isMobile ? 1 : 2" rowHeight="50px" class="grid-list-container">
                    <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                      <tdo-input placeholder="First Name" placeholderPosition="above"
                        cypressControlIdentifier="Insurance-FirstName"
                        style="width: 100%"
                        type ="text"
                        [value]="this.ReferralData.Insurance_FirstName"
                      (inputFinished)="this.ReferralData.Insurance_FirstName = $event" data-cy="referral-portal-insurance-firstname-input"></tdo-input>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                      <tdo-input placeholder="Last Name" placeholderPosition="above"
                        cypressControlIdentifier="Insurance-LastName"
                        style="width: 100%"
                        type ="text"
                        [value]="this.ReferralData.Insurance_LastName"
                      (inputFinished)="this.ReferralData.Insurance_LastName = $event" data-cy="referral-portal-insurance-lastname-input"></tdo-input>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
                      @if (this.SelfInsurance) {
                        <tdo-date-input widthString="100%" placeholder="Date Of Birth"
                          [isRequired]="false"
                          cypressControlIdentifier="Insurance-DOB"
                          placeholderPosition="center"
                          style="width: 100%"
                          [valueAsDate]="getDate(this.ReferralData.Patient_DOB)"
                          (dateChanged)="this.ReferralData.Insurance_DOB = $event; this.ReferralData.Insurance_DOB = $event" data-cy="referral-portal-insurance-dob-self-input">
                        </tdo-date-input>
                      }
                      @if (!this.SelfInsurance) {
                        <tdo-date-input widthString="100%" placeholder="Date Of Birth"
                          [isRequired]="false"
                          cypressControlIdentifier="Insurance-DOB"
                          placeholderPosition="center"
                          style="width: 100%"
                          [valueAsDate]="getDate(this.ReferralData.Insurance_DOB)"
                          (dateChanged)="this.ReferralData.Insurance_DOB = $event; this.ReferralData.Insurance_DOB = $event" data-cy="referral-portal-insurance-dob-input">
                        </tdo-date-input>
                      }
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                      <tdo-input placeholder="Insurance Company" placeholderPosition="above"
                        cypressControlIdentifier="Insurance-Company"
                        style="width: 100%"
                        type ="text"
                        [value]="this.ReferralData.Insurance_Company"
                      (inputFinished)="this.ReferralData.Insurance_Company = $event" data-cy="referral-portal-insurance-company-input"></tdo-input>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                      <tdo-input placeholder="Insurance Number" placeholderPosition="above"
                        cypressControlIdentifier="Insurance-Number"
                        style="width: 100%"
                        type ="text"
                        [value]="this.ReferralData.Insurance_Number"
                      (inputFinished)="this.ReferralData.Insurance_Number = $event" data-cy="referral-portal-insurance-number-input"></tdo-input>
                    </mat-grid-tile>
                  </mat-grid-list>
                  <span class="insurance-note" data-cy="referral-portal-insurance-card-note">Please attach an image of the insurance card, if applicable.</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="content-column-right">
            <mat-card class="Card-style card-teeth-height" data-cy="referral-portal-teeth-card">
              <mat-card-title-group>
                <mat-card-title class="Card-title" data-cy="referral-portal-teeth-title">select teeth*</mat-card-title>
              </mat-card-title-group>
              <mat-card-content class="divDBInfoScrollHorizontal">
                <div class="checkbox-list" data-cy="referral-portal-upper-teeth-list">
                  @for (item of ListOfUpperTeeth; track item; let i = $index) {
                    <div class="checkbox-item">
                      <div class="checkbox-style">
                        <mat-checkbox (change)="selectedUpperTeeth(item)" [attr.data-cy]="'selectedUpperTeeth-' + i" [checked]="item.checked"></mat-checkbox>
                        <div class="text" data-cy="referral-portal-upper-teeth-notation">{{ item.Notation }}</div>
                      </div>
                    </div>
                  }
                </div>
                <div class="checkbox-list" data-cy="referral-portal-lower-teeth-list">
                  @for (item of ListOfLowerTeeth; track item; let i = $index) {
                    <div class="checkbox-item">
                      <div class="checkbox-style">
                        <div class="text" data-cy="referral-portal-lower-teeth-notation">{{ item.Notation }}</div>
                        <mat-checkbox (change)="selectedLowerTeeth(item)" [attr.data-cy]="'selectedlowerTeeth-' + i" [checked]="item.checked"></mat-checkbox>
                      </div>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="Card-style card-discomfort-height" data-cy="referral-portal-discomfort-card">
              <mat-card-title-group>
                <mat-card-title class="Card-title" data-cy="referral-portal-discomfort-title">Discomfort Level</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>
                <mat-radio-group [(ngModel)]="this.ReferralData.DiscomfortLevel"
                  class="horizontal-radio-list" data-cy="referral-portal-discomfort-group">
                  @for (ent of DiscomfortLevelList; track ent; let i = $index) {
                    <mat-radio-button class="radio-button"
                      (click)="changeDiscomfort(ent)"
                      [value]="ent.id"
                      [attr.data-cy]="'DiscomfortLevel-' + i">
                      {{ent.value}}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </mat-card-content>
            </mat-card>
            <div class="treatment-services-row">
              <mat-card class="Card-style card-treatment-height" style="max-height: 200px" data-cy="referral-portal-treatment-card">
                <mat-card-title-group>
                  <mat-card-title class="Card-title" data-cy="referral-portal-treatment-title">Treatment Requested*</mat-card-title>
                </mat-card-title-group>
                <mat-card-content class="divDBInfoScroll content-card-1">
                  @if (currentProvider) {
                    <div class="card-content-wrapper">
                      <mat-selection-list [multiple]="true" name="ReferralTreatmentList" #referralTreatmentRequestedList data-cy="referral-portal-treatment-list">
                        @for (ent of currentProvider.cfgReferralTretment; track ent; let i = $index) {
                          <mat-list-option
                            (click)="changeReferralTreatment(ent)"
                            [attr.data-cy]="'ReferralTreatment-' + i">
                            {{ent.ItemName}}
                          </mat-list-option>
                        }
                      </mat-selection-list>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
              <mat-card class="Card-style card-treatment-height" style="max-height: 200px" data-cy="referral-portal-services-card">
                <mat-card-title-group>
                  <mat-card-title class="Card-title" data-cy="referral-portal-services-title">Other Services</mat-card-title>
                </mat-card-title-group>
                <mat-card-content class="divDBInfoScroll content-card-1">
                  @if (currentProvider) {
                    <div class="card-content-wrapper">
                      <mat-selection-list [multiple]="true" #otherServicesList data-cy="referral-portal-services-list">
                        @for (ent of currentProvider.cfgReferralOtherService; track ent; let i = $index) {
                          <mat-list-option
                            (click)="changeReferralOtherService(ent)"
                            [attr.data-cy]="'ReferralOtherService-' + i">
                            {{ent.ItemName}}
                          </mat-list-option>
                        }
                      </mat-selection-list>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
        <div class="bottom-row">
          <div class="bottom-column-files">
            <mat-card class="Card-style card-files-height" data-cy="referral-portal-files-card">
              <mat-card-title-group>
                <mat-card-title class="Card-title" data-cy="referral-portal-files-title">Attach Files</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>
                <div appDragFileToBrowser (files)="onFilesDropped($event)" class="dropzone" data-cy="referral-portal-files-dropzone">
                  @for (item of documents; track item; let i = $index) {
                    <div class="image-container" [attr.data-cy]="'referral-portal-file-' + i">
                      <img class="document-image" alt="Document Type" [src]="getDocumentTypeFromUrl(documents[i])" data-cy="referral-portal-file-image"/>
                      <label data-cy="referral-portal-file-description">{{documents[i].Description}}</label>
                      <lucide-icon name="trash-2" [size]="20" (click)="DeleteFile(documents[i])" class="delete-icon" data-cy="referral-portal-file-delete"></lucide-icon>
                    </div>
                  }
                  @if (documents.length === 0) {
                    <div class="dropzone-empty">
                      <lucide-icon name="image" [size]="20" class="empty-icon" data-cy="referral-portal-files-empty"></lucide-icon>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="bottom-column-notes">
            <mat-card class="Card-style card-files-height" data-cy="referral-portal-notes-card">
              <mat-card-title-group>
                <mat-card-title class="Card-title" data-cy="referral-portal-notes-title">Notes</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>
                <div class="notes-content-wrapper">
                  <mat-form-field class="notes-field" data-cy="referral-portal-notes-field">
                    <textarea matInput [(ngModel)]="ReferralData.Notes" [attr.class]="'notes-textarea'" [attr.style]="'height: 110px !important;'" [attr.data-cy]="'referral-portal-notes-textarea'"></textarea>
                  </mat-form-field>
                  <br/>
                  <button mat-button class="tdo-button tdo-save submit-button" (click)="Submit()"
                    [disabled]="CheckIfSaveDisabled()"
                    [attr.data-cy]="'submitReferralPortalInformation'" data-cy="referral-portal-submit-button">Submit
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  }
@if (!this.authorizedUser && !isLoading) {
    <div class="error-container" data-cy="referral-portal-unauthorized">
      <div #errorCard
        class="error-card"
        role="alert"
        tabindex="-1"
        aria-labelledby="error-card-title"
        aria-describedby="error-card-message">
        <mat-icon class="error-icon" aria-hidden="true">{{hasError ? 'link_off' : 'lock_outline'}}</mat-icon>
        <h2 id="error-card-title" class="error-title" data-cy="referral-portal-error-title">{{errorTitle || 'Access Denied'}}</h2>
        <p id="error-card-message" class="error-message" data-cy="referral-portal-error-message">
          {{errorMessage || 'You do not have permission to access this referral portal.'}}
        </p>
        <p class="error-contact">If you need further assistance, please reach out to your referring dental office.</p>
      </div>
    </div>
  }

</div>